import React, { useEffect, useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import { Button, Stack, TextField, Box } from "@mui/material";
import DefaultHeading from '../heading/DefaultHeading';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useNavigate } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { getGlobalFilters, getFeatureDataForId, createFeatureMetadata, updateFeatureMetadata } from "../../features/manageDisplayCapture/manageDisplayCaptureService";
import store from "../../stateManagement/store";
import GenericFilters from '../genericFilters/genericFilters';
import { useLocation } from 'react-router-dom';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { Loader } from "../loader/Loader";
import { DisplayCapture } from "../../features/manageDisplayCapture/manageDisplayCaptureType";
import { channel } from "diagnostics_channel";

const ManageDisplayCreate = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const [startDate, setStartDate] = useState<Dayjs | null>(null);
    const [endDate, setEndDate] = useState<Dayjs | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<Record<string, any>>({});
    const [isUpdate, setUpdate] = useState<boolean>(false);
    const [formData, setFormData] = useState<DisplayCapture>({
        featureName: "",
        featureDescription: "",
        startDate: dayjs().subtract(1, 'day').format("YYYY-MM-DD HH:mm:ss"),
        endDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        channel: [],
        supplier: [],
        campaign: "Display Capture",
    });

    const [resetFiltersFlag, setResetFiltersFlag] = React.useState<boolean>(false);
    const [genericFilter, setGenericFilter] = React.useState<any[]>([]);
    const [filtersPresent, setFiltersPresent] = React.useState<boolean>(false);

    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    };

    const query = useQuery();
    const formType = query.get('type');

    useEffect(() => {
        if (formType === "edit") {
            let id = query.get('job');
            getAndSetData(id)
        }
    }, []);

    const getAndSetData = async (id: any) => {
        setLoading(true);
        try {
            if (formType === "edit") {
                setUpdate(true);
                let response: Record<string, any> = await getFeatureDataForId(id)
                setData(response[0]);
                setFormData(() => ({
                    featureName: response[0]?.featureName,
                    featureDescription: response[0]?.featureDescription,
                    startDate: response[0]?.startDate,
                    endDate: response[0]?.endDate,
                    channel: response[0]?.channel,
                    supplier: response[0]?.supplier,
                    campaign: "Display Capture",
                }));
                setStartDate(dayjs(response[0]?.startDate));
                setEndDate(dayjs(response[0]?.endDate));
            }
        }
        catch {
            openPopup("Error", "Error While Reteriving Data");
        }
        finally {
            setLoading(false);
        }
    }

    const handleSubmit = async () => {
        const genericFilterData = store?.getState()?.genericFilter;
        let loginIds: string[] = genericFilterData.loginId as string[];
        let channels: string[] = genericFilterData.channel as string[];

        const missingFields = 
        (filtersPresent && !loginIds?.length ? 'Distributor ' : '') +
        (filtersPresent && !channels?.length ? 'Channel ' : '') +
            (!startDate ? ' Start Date' : '') + (!endDate ? ' End Date' : '') + (!formData.featureName ? ' Feature Name' : '') + (!formData.featureDescription ? ' Feature Description' : '');
            const isValid =
            (!filtersPresent || (loginIds?.length && channels?.length)) &&
            startDate &&
            endDate &&
            formData.featureName &&
            formData.featureDescription;
            if (isValid) {
            const requestBody: DisplayCapture = {
                featureName: formData.featureName,
                featureDescription: formData.featureDescription,
                endDate: endDate.format("YYYY-MM-DD HH:mm:ss"),
                startDate: startDate.format("YYYY-MM-DD HH:mm:ss"),
                supplier: [...(loginIds || [])],
                channel: [...(channels || [])],
                campaign: formData.campaign,
            }
            try {
                if (isUpdate) {
                    await updateFeatureMetadata(requestBody.campaign, requestBody);
                } else {
                    await createFeatureMetadata(requestBody);
                }
                navigate(location.pathname.replace(/\/([^/]*)$/, ''));
            }
            catch {
                openPopup("Error", "Something Went Wrong");
            }
        }
        else {
            openPopup("Alert", 'Please Fill ' + missingFields);
        }

    }

    const handleReset = () => {
        if (isUpdate) {
            setFormData(() => ({
                featureName: data.featureName,
                featureDescription: data.featureDescription,
                startDate: data.startDate,
                endDate: data.endDate,
                channel: data.channel,
                supplier: data.supplier,
                campaign: "Display Capture",
            }));
            setStartDate(dayjs(data.startDate));
            setEndDate(dayjs(data.endDate));
        }
        else {
            setFormData(() => ({
                featureName: "",
                featureDescription: "",
                startDate: dayjs().subtract(1, 'day').format("YYYY-MM-DD HH:mm:ss"),
                endDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
                channel: [],
                supplier: [],
                campaign: "Display Capture",
            }));
            setStartDate(null);
            setEndDate(null);
        }
    }

    const handleStartDateChange = (newDate: Dayjs | null) => {
        setStartDate(newDate);
        setEndDate(null);
    };

    const handleChange = (id: string, newValue: string) => {
        setFormData((prevData) => ({
            ...prevData,
            [id]: newValue,
        }));
    };

    useEffect(() => {
        const getAndSetGlobalFilters = async () => {
            const filters = await getGlobalFilters("campaignGlobalFilter");
            if (filters.length) {
                setGenericFilter(filters);
                setFiltersPresent(true);
            }
        }
        getAndSetGlobalFilters();
    }, [])

    return <div className="manage_display_create_container">
        {
            loading ? <Loader /> :
                <><div className="notifications_container">
                    {genericFilter && genericFilter.length !== 0 &&
                        <div className="push-notification-inner-container" >
                            <DefaultHeading heading="Campaign Filters" showDefaultBackButton={true} />
                            <Box className="generic-filter-container">
                                <GenericFilters filterOptions={genericFilter} resetFiltersFlag={resetFiltersFlag} preSelectedData={{ loginId: data?.supplier?.join(',') || null, channel: data?.channel?.join(',') || null }} />
                            </Box>
                        </div>
                    }
                </div>
                    <div className="campaign_container">
                        <DefaultHeading heading='Campaign Description' showDefaultBackButton={true} />
                        <form className='campaign_form'>
                            <div className="campaign_fields">
                                <TextField
                                    label="Image Name"
                                    type="text"
                                    id="featureName"
                                    disabled={isUpdate}
                                    required
                                    value={formData.featureName || ""}
                                    onChange={(event) => handleChange(event.target.id, event.target.value)}
                                />
                                <TextField
                                    label="Image Description"
                                    type="text"
                                    id="featureDescription"
                                    disabled={isUpdate}
                                    required
                                    value={formData.featureDescription || ""}
                                    onChange={(event) => handleChange(event.target.id, event.target.value)}
                                />
                            </div>
                            <div className="campaign_date_picker">
                                <Stack spacing={2.8} direction={"row"} className="date-pickers">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label="From Date"
                                            inputFormat="DD-MM-YYYY"
                                            value={startDate}
                                            onChange={handleStartDateChange}
                                            minDate={!isUpdate ? dayjs() : undefined}
                                            renderInput={(props) => (
                                                <TextField {...props} required disabled size="small" />
                                            )}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label="To Date"
                                            inputFormat="DD-MM-YYYY"
                                            value={endDate}
                                            onChange={(value) => {
                                                if (value) {
                                                    setEndDate(value);
                                                }

                                            }}
                                            minDate={startDate || dayjs()}
                                            disabled={!startDate}
                                            renderInput={(props) => (
                                                <TextField {...props} required disabled size="small" />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </Stack>
                            </div>
                            <div className="campaign_buttons">
                                <Button variant="contained" onClick={() => { handleSubmit() }} style={{ backgroundColor: "#909090" }}>SUBMIT</Button>
                                <Button variant="contained" style={{ backgroundColor: "#909090" }} onClick={() => { handleReset() }}>RESET</Button>
                            </div>
                        </form>
                    </div>
                </>
        }

    </div>
}

export default ManageDisplayCreate;
